<div class="page-title" data-cy="claim-title">Claims</div>
<app-claim-list (reportCriteria)="setReportCriteria($event)"></app-claim-list>